import { createContext } from 'react';

type GetStartedContextValue = [boolean, () => unknown];

export const GetStartedContext = createContext<GetStartedContextValue>(null);